import { Component, OnInit, Input, Output, EventEmitter, ViewChild,ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import moment from 'moment';

import { environment } from '../../../../../environments/environment';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-montants-teom',
    templateUrl: './montants-teom.component.html',
    styleUrls: ['./montants-teom.component.css'],
    standalone: false
})
export class MontantsTeomComponent implements OnInit ,OnDestroy {
    @Input() detail;
    @Input() edit: Boolean;
    @Input() add: Boolean;
    @Output() show = new EventEmitter<any>();

    isEmpty: Boolean = true;
    renderTable: Boolean = true;
    isHisto: Boolean = false;
    default = 0;
    focusIndex = 0;
    listMontantsTeom = [];
    deleteElm = [];
    selectedRow: any = {};
    urlecoportail;
    ligneAValider;
    listAnnee = [];
    @ViewChild('confirme') confirme;
    @ViewChild('msg') msg;
    @ViewChild('confirmeSupp') confirmeSupp;
    error
    justificatif
    teomASupprimer = {}
    constructor(public common: CommonService, private modalService: BsModalService) {
    }



    ngOnInit() {
      this.urlecoportail = environment.api_dmd;
      this.common.isTableauContainer = true;
      this.getListMontantsTeom().then(() => {
        this.isEmpty = false;
      });

      let a = 2019;
      for(a; a<2030; a++) {
          this.listAnnee.push(a)
      }
    }

    ngOnDestroy(): void {
      this.common.isTableauContainer = false;
    }

    parseDate() {
      if(this.listMontantsTeom) {
          this.listMontantsTeom.forEach(elt => {
            // elt.date = elt.date ? moment(elt.date, 'DD/MM/YYYY').format('DD/MM/YYYY')
            // : moment().format('DD/MM/YYYY');
          });
      }
    }

    hide() {
      this.show.emit();
    }

    change(row) {
      row.edit = true;
    }

    deleteLigne() {
      const temp = this.listMontantsTeom.filter(elt => elt !== this.teomASupprimer);
      this.listMontantsTeom = temp;
      this.saveModif()
    }


    addLigne() {
      this.listMontantsTeom.push({
        index: this.listMontantsTeom.length, id: 0, date: moment().format('DD/MM/YYYY')
      });
      this.listMontantsTeom = [...this.listMontantsTeom];
      const length = this.listMontantsTeom.length - 1;
      setTimeout(function () {
        $('.date' + (length)).focus();
      }, 600);
    }

    getListMontantsTeom() {
        const param = {
          'servlet': 'DBGestionTeom',
          'module': 'Recylog',
          'type': 'map',
          'compression': 'false',
          'data': {
            'OPERATION': {
              'typeParam': 'int',
              'valeur': 2
            },
            'CLEF_CLIENT': {
              'typeParam': 'int',
              'valeur': this.detail['id'] || 0
            },
            'CLEF_USER': {
              'typeParam': 'int',
              'valeur': this.common.user[0]
            }
          }
        };

        return this.common.post('', { param: param }).then(datas => {
            $('#empty').trigger('click');
            $('.ligneBon').trigger('click');
            if (this.common.verifySession(datas)) {
                this.listMontantsTeom = datas.data;
                this.listMontantsTeom.forEach(el => {
                  if(el.dateCreation) { 
                    el.dateCreationAffiche =el.datecreation
                  }
                  el.libelleLieu = 
                  (el.chantier ? (el.chantier.numChantier2 ? el.chantier.numChantier2 + '/' : '') : '') +
                  (el.chantier ? (el.chantier.numChantier ? el.chantier.numChantier : '') : '') +
                  (el.chantier ? (el.chantier.responsable ? '/ ' + el.chantier.responsable : '') : '') +
                  (el.chantier ? (el.chantier.adresse1 ? ' / ' + el.chantier.adresse1 : '') : '') +
                  (el.chantier ? (el.chantier.ville ? '/ ' + el.chantier.ville : '') : '');
                  });

                this.parseDate();
            }
        });
    }

    focus(event) {
      const input = event.target;
      const originalValue = $(input).val();
      $(input).val('');
      $(input).blur().focus().val(originalValue);
    }

    confirmationValide(row) {
        this.ligneAValider = row;
        this.common.openModal(this.modalService, this.confirme);
    }
    
    valide() {
        const param = {
          'servlet': 'DBGestionTeom',
          'module': 'Recylog',
          'type': 'map',
          'compression': 'false',
          'data': {
            'OPERATION': {
              'typeParam': 'int',
              'valeur': 3
            },
            'CLEF_TEOM': {
              'typeParam': 'int',
              'valeur': this.ligneAValider['id']
            },
            'CLEF_USER': {
              'typeParam': 'int',
              'valeur': this.common.user[0]
            }
          }
        };
        return this.common.post('', { param: param }).then(datas => {
            this.getListMontantsTeom();
            this.common.closeModal();
        });        
    }

    isEdit : Boolean = false
  showFormEdit(row) {
    this.selectedRow = Object.assign({}, row);
    this.isEdit = !this.isEdit;
    this.selectedRow['index'] = this.selectedRow['index'] || this.listMontantsTeom.length
    this.selectedRow['dateCreation'] = this.selectedRow['dateCreation'] || moment().format('DD/MM/YYYY HH:mm:ss');
        const datecreation = this.selectedRow['dateCreation'] ? moment(this.selectedRow['dateCreation'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
              this.selectedRow['dateCreation'];
        this.selectedRow['dateCreationModel'] =   this.common.parseDate(datecreation);

        this.selectedRow['justificatifs'] = [];
        this.selectedRow['doc']= this.selectedRow['doc'] || '';
        this.selectedRow['doc2']= this.selectedRow['doc2'] || '';
        this.selectedRow['doc3']= this.selectedRow['doc3'] || '';
        this.selectedRow['doc4']= this.selectedRow['doc4'] || '';
        // this.isEdit = !this.isEdit;
        const positions = [1, 2, 3, 4];

        positions.forEach(pos => {
          const key = pos === 1 ? 'doc' : `doc${pos}`;
          const value = this.selectedRow?.[key];

          if (value) {
            this.selectedRow['justificatifs'].push({
              nomFichier: value,
              binary: null,
              url: `${this.urlecoportail}/DownloadDocTeom?filename=${value}`,
              position: pos  ,
              isDepuisServeur: true
            });
          }
        });

  }
  listChantier = []
  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'GET_CHANTIERS_CRITERE_VIDE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  validationLigne(index) {

    if(!this.selectedRow.annee) {
      this.error = 'Le champs année est obligatoires.';
      this.common.openModal(this.modalService, this.msg);            
      return false;
  }                
          
  if(!this.selectedRow.chantier) {
      this.error = 'Le champs chantier est obligatoires.';
      this.common.openModal(this.modalService, this.msg);            
      return false;
  }
  
  if(!this.selectedRow.valeur) {
    this.error = 'Le champs montant restant  est obligatoires.';
    this.common.openModal(this.modalService, this.msg);            
    return;
}
if(!this.selectedRow.valeurInitiale) {
  this.error = 'Le champs montant  est obligatoires.';
  this.common.openModal(this.modalService, this.msg);            
  return;
}
  
  if(this.selectedRow.justificatifs && !this.selectedRow.justificatifs.length) {
      this.error = 'Le champs justificatif est obligatoire';
      this.common.openModal(this.modalService, this.msg);            
      return;
  }        
  
  if(!this.validationAnneeCouple()) {
      this.error = 'Ce couple Annee/Lieu existe déjà';
      this.common.openModal(this.modalService, this.msg);            
      return;            
  }
    if(!this.selectedRow.id) {
      this.listMontantsTeom.push(this.selectedRow);
      this.listMontantsTeom = [...this.listMontantsTeom];
      const item = this.listMontantsTeom.find(el => el.index === this.selectedRow.index);
      if(item) {
        Object.assign(item, this.selectedRow);
      }
    } else {
      const item = this.listMontantsTeom.find(el => el.id === this.selectedRow.id);
      if (item) {
        Object.assign(item, this.selectedRow);
      }
    }
    console.log('this.listMontantsTeom', this.listMontantsTeom);

    this.listMontantsTeom.forEach(el => {
      if (el.isExistPiece) {// on ajoute les justificatifs dans l'objet teom
        if (el.justificatifs && el.justificatifs.length > 0) {
          const eltJustificatifNew = el.justificatifs.filter(doc => !doc.isDepuisServeur) || []; // Justificatifs non présents sur le serveur
          eltJustificatifNew.forEach((doc, index) => {
            if (doc.position == 1) {
              el.docFileObject = doc
            }

            if (doc.position == 2) {
              el.docFileObject2 = doc
            }

            if (doc.position == 3) {
              el.docFileObject3 = doc
            }

            if (doc.position == 4) {
              el.docFileObject4 = doc
            }
          });
        }
      }
    });

    this.saveModif();
  }

  saveModif() {
    this.listMontantsTeom.forEach(el => {
      el.nomclass ="Teom";
    });

    const param = {
      'servlet': 'DBGestionTeom',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        LISTE_TEOM :this.listMontantsTeom
      }
    };

    return this.common.post('', { param: param },true).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.isEdit = false;
        this.getListMontantsTeom().then(() => {
          this.isEmpty = false;
        });
      }
    }).catch((error)=>{
      if (error.message && error.message.includes('Utilisateur non-autentifié')) {
        this.common.logout();
    } else {
        this.error = error;
        this.common.openModal(this.modalService, this.msg);
    }
    })
  }

  validerFormEdit() {
    this.validationLigne(0) 
}

parseData(newEntity) {
  const value = JSON.stringify(newEntity);
  const replace = value.split('%').join('\\u0025');
  const valeur = replace.split('&').join('\\u0026');
  const lastval = valeur.split('+').join('\\u002B');
  return lastval;
}  

validationAnneeCouple() {
  let anneeCoupleValide = true;
  this.listMontantsTeom.forEach(teom => {
      if(teom.id > 0 && 
          teom.id != this.selectedRow.id &&
          teom.annee == this.selectedRow.annee && teom.chantier && teom.chantier.id == this.selectedRow.chantier.id) {
          anneeCoupleValide = false;
      }
  });
  
  return anneeCoupleValide;
}
justificatifs:any[]=[]


getNameFile(event: any, selectedRow: any) {
  const files: FileList = event.target.files;
  selectedRow.justificatifs = selectedRow.justificatifs || [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    // Vérif extension
    if (!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);
      continue;
    }
    // Limiter à 4 justificatifs
    if (selectedRow.justificatifs.length >= 4) {
      break;
    }

    // Trouver position dispo entre 1 ... 4
    const position = this.getEmplementLibre(selectedRow);
    // Création de l'objet justificatif
    const item: any = {
      nomFichier: file.name,
      binary: file,
      nomFichierOriginal: file.name,
      url: URL.createObjectURL(file), // Aperçu
      isDepuisServeur: false,
      position: position
    };

    // Lecture en Base64
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const base64 = (fileReader.result as string).split(',');
      item.file = fileReader.result;
      item.contentBase64 = base64[1]; 
      item.nomclass = 'FileObject';

      // Ajout à la liste une fois le Base64 prêt
      selectedRow.justificatifs.push(item);

      // Met à jour les infos dans la ligne
      selectedRow['doc' + (position > 1 ? position : '')] = file.name;
      
      selectedRow['isExistPiece'] = true;
    };
    fileReader.readAsDataURL(file);
  }
  event.target.value = '';
}


getEmplementLibre(data) {
  const emptyKey = Object.keys(data)
    .filter(key => /^doc\d*$/.test(key))
    .find(key => !data[key]); 

  if (!emptyKey) return 0;

  const match = emptyKey.match(/\d+/);
  return match ? parseInt(match[0], 10) : 1;
}

  deleteLigneConfirmation(row) {
    this.teomASupprimer = row;
    this.common.openModal(this.modalService, this.confirmeSupp);
  }

  changeMontant(selectRow) {
    if(!this.selectedRow.id) {
      this.selectedRow['valeurInitiale'] = this.selectedRow['valeur']
    }
  }

  removeJustificatif(index: number, file: any,selectedRow) {
    this.removeInTeom(index, file.nomFichier,selectedRow
    );
    selectedRow.justificatifs.splice(index, 1);
  }

  removeInTeom(index: number, doc: string,selectedRow) {
    if (!selectedRow) return;

    if (selectedRow.doc === doc) {
      selectedRow.doc = null;
    } if (selectedRow.doc2 === doc) {
      selectedRow.doc2 = null;
    }
    if (selectedRow.doc3 === doc) {
      selectedRow.doc3 = null;
    }
    if (selectedRow.doc4 === doc) {
      selectedRow.doc4 = null;
    }
  }

    changeDateCreation(event, row) {
      if (moment(event).isValid()) {
        row['dateCreation'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
        console.log(row['dateCreation']);
      } else {
        row['dateCreation'] = moment().format('DD/MM/YYYY HH:mm:ss');
        console.log(row['dateCreation']);
      }
    }

}
